import capitalize from 'lodash/capitalize'

export default function getLanguageStatusForLanguagesView(status: string): [string, string] {
  const allowedStatuses = [
    'done',
    'new',
    'pending_transcript',
    'insufficient_credits',
    'waiting_review_for_voice_generation'
  ]

  const baseStatus = allowedStatuses.includes(status) ? status : 'in_progress'

  const languageStatusClass = baseStatus.split('_').slice(0, 2).join('_')

  const languageStatusToRender = capitalize(languageStatusClass.replace(/_/g, ' '))

  return [languageStatusClass, languageStatusToRender]
}
